export default __webpack_public_path__ + "static/media/white_users_icon.9bb761d0.svg";